var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail",attrs:{"id":"index"}},[_c('h4',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.msgTitle)+" ")]),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.msgPushtime))]),_c('div',{staticClass:"info"},[_c('p'),_c('div',{domProps:{"innerHTML":_vm._s(_vm.msgContent)}}),_c('p')])])
}
var staticRenderFns = []

export { render, staticRenderFns }